module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAUNJREFUOE+lk79KA0EQxr8dCGms7LQSLAVbWwstBAUfQEtvbkkvKIixUdInXOYKq5DCThQUtEghgg8hCIK+gM0RmJGVJFw0F05d2GJ3vu/Hzp91+OdyRf5WqzVTqVR2Qrzf73dqtdrHJO0PgIisqOoGEQXz4sD0rKodIrph5qc8aARIkqRORMclMnpV1XPvfT1o/wKAqp78GmBml3Ecb4uITQU453pmNgtgOZdON8syX61WHwEsTQWEIBEJgAaAXQBNImqo6m0wB2iZFLoA9lR13zl3EfbQXAhI03TTzK5yz35Q1SMiaubNX5V3biuKouuxLojIHIC3Em0Mknlmfh8DhEO73T51zh1Mg5jZWRzHh0PNpEm8A7BWALln5vWJk5i/FJEIQOhEfjEzp9/BhZ8pSZIFAKsDQ897/1LqM5Us4kj2CTsQkBGadFsDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safety.png
// module id = sbYV
// module chunks = 1